import { FC, useState, useEffect } from "react";
import { http } from "../../http";
import { API_BASE_URL } from "Constants";
import { Hub } from "Types/App";
import HubsTable from "Components/Sponsor/HubsTable";
import { useHistory } from "react-router-dom";
import { AdminPage, AdminError, PrimaryButton, EmptyState } from "./adminShared";

type HubsPageProps = {};

interface HubsResponse {
  hubs: Hub[];
}

export const HubsPage: FC<HubsPageProps> = () => {
  const history = useHistory();

  const [error, setError] = useState<string>("");
  const [hubs, setHubs] = useState<Hub[]>([]);
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    getHubs();
  }, []);

  const getHubs = async () => {
    try {
      const response = await http<HubsResponse>(API_BASE_URL + "/sponsor/hubs", "GET");
      const body = response.parsedBody;
      if (!body) {
        setError("response error");
        return;
      }
      setHubs(body.hubs);
    } catch (ex: any) {
      setError(ex.toString());
    } finally {
      setLoaded(true);
    }
  };

  return (
    <AdminPage
      eyebrow="STORES"
      title="店舗一覧"
      icon="shop"
      action={
        <PrimaryButton icon="plus" onClick={() => history.push("/sponsor/hubs/add")}>
          店舗を追加する
        </PrimaryButton>
      }
    >
      <AdminError error={error} />
      {loaded && hubs.length === 0 ? (
        <EmptyState
          icon="shop"
          title="まだ店舗がありません"
          description="最初の店舗を登録してクーポンの発行を始めましょう。"
          action={
            <PrimaryButton icon="plus" onClick={() => history.push("/sponsor/hubs/add")}>
              店舗を追加する
            </PrimaryButton>
          }
        />
      ) : (
        <HubsTable hubs={hubs} />
      )}
    </AdminPage>
  );
};
